import { CdkStepper, CdkStepperModule } from '@angular/cdk/stepper';
import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TooltipDirective } from 'src/app/shared/ui/tooltip/tooltip.component';

@Component({
    selector: 'app-stepper-container',
    templateUrl: './stepper-container.component.html',
    styleUrls: ['./stepper-container.component.scss'],
    imports: [CdkStepperModule, CommonModule, TooltipDirective],
    providers: [{ provide: CdkStepper, useExisting: ExamStepperComponent }]
})
export class ExamStepperComponent extends CdkStepper {
  selectStepByIndex(index: number): void {
    this.selectedIndex = index;
  }
}
